var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 8,
    viewBox: "-10 -3 50 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf_1_",
    "data-name": "pdf (1)",
    transform: "translate(-24.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90458",
    "data-name": "Path 90458",
    d: "M28.47,268.483H27.414a2.64,2.64,0,0,1-2.64-2.64,1.584,1.584,0,0,1,1.584-1.584H28.47v4.224Z",
    transform: "translate(0 -247.362)",
    fill: "#bd4150"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90459",
    "data-name": "Path 90459",
    d: "M102.414,0H82.877l-.544,1.056V32.227h24.834l1.056-.545V5.808Z",
    transform: "translate(-53.879 0)",
    fill: "#eceaec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90460",
    "data-name": "Path 90460",
    d: "M75.379,30.1V0a1.056,1.056,0,0,0-1.056,1.056V31.682a1.056,1.056,0,0,0,1.056,1.056h24.29a1.056,1.056,0,0,0,1.056-1.056H76.963A1.584,1.584,0,0,1,75.379,30.1Z",
    transform: "translate(-46.381 0)",
    fill: "#dad8db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90461",
    "data-name": "Path 90461",
    d: "M402.2,5.718a1.056,1.056,0,0,0-.309-.747L397.224.309A1.056,1.056,0,0,0,396.477,0h-.09V5.28a.528.528,0,0,0,.528.528h5.28Z",
    transform: "translate(-347.851)",
    fill: "#dad8db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90462",
    "data-name": "Path 90462",
    d: "M50.739,312.486H34.37a1.581,1.581,0,0,1-.528-.09l-.509.849v6.671a1.584,1.584,0,0,0,1.584,1.584H50.739l1.056-.565v-7.392A1.056,1.056,0,0,0,50.739,312.486Z",
    transform: "translate(-8.012 -292.421)",
    fill: "#e15f78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90463",
    "data-name": "Path 90463",
    d: "M25.83,290.526a1.588,1.588,0,0,1-1.056-1.494v9.5a1.584,1.584,0,0,0,1.584,1.584H42.727a1.056,1.056,0,0,0,1.056-1.056H27.414a1.584,1.584,0,0,1-1.584-1.584Z",
    transform: "translate(0 -270.551)",
    fill: "#db4655"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116584",
    "data-name": "Group 116584",
    transform: "translate(28.455 22.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90464",
    "data-name": "Path 90464",
    d: "M229.819,349.138h-1.036v-1h1.172a.528.528,0,0,0,0-1.056h-1.7a.528.528,0,0,0-.528.528V351.8a.528.528,0,0,0,1.056,0v-1.608h1.036a.528.528,0,0,0,0-1.056Z",
    transform: "translate(-218.43 -347.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90465",
    "data-name": "Path 90465",
    d: "M84.042,346.839H82.866a.528.528,0,0,0-.528.528h0v4.224a.528.528,0,0,0,1.056,0v-1.31l.648,0a1.72,1.72,0,1,0,0-3.44Zm0,2.384-.643,0c0-.244,0-1.33,0-1.33h.647a.664.664,0,1,1,0,1.328Z",
    transform: "translate(-82.338 -346.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90466",
    "data-name": "Path 90466",
    d: "M153.52,347.815h-1.161a.528.528,0,0,0-.528.529l0,2.044c0,.57.005,2.056.005,2.056a.528.528,0,0,0,.528.526h0s.861,0,1.194-.009a2.33,2.33,0,0,0,2.141-2.569C155.7,348.851,154.826,347.815,153.52,347.815Zm.025,4.09c-.151,0-.413,0-.651.006,0-.483,0-1.175,0-1.524l0-1.517h.632c1.074,0,1.128,1.268,1.128,1.522C154.647,351.136,154.307,351.892,153.544,351.905Z",
    transform: "translate(-147.387 -347.753)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_90467",
    "data-name": "Path 90467",
    d: "M179.423,89.365a1.223,1.223,0,0,1-1.034-.612,1.411,1.411,0,0,1,.277-1.844,8.136,8.136,0,0,1,3.114-1.581,27.151,27.151,0,0,0,1.289-2.835c.244-.626.441-1.19.6-1.694a6.118,6.118,0,0,1-1-3.233,1.349,1.349,0,0,1,1.565-1.175c.258.014.873.149,1.022,1.1a8.6,8.6,0,0,1-.46,3.226,20.083,20.083,0,0,0,2.688,3.534,6.6,6.6,0,0,1,3.337.395,1.058,1.058,0,0,1,.515,1.289,1.411,1.411,0,0,1-1.774,1.023,6.118,6.118,0,0,1-2.464-1.634,24.6,24.6,0,0,0-4.573.848c-.878,1.576-1.828,2.8-2.625,3.108A1.319,1.319,0,0,1,179.423,89.365Zm-.148-1.186c.088.136.137.133.159.13.336-.034.9-.615,1.536-1.6a7.148,7.148,0,0,0-1.121.589C179.05,87.832,179.22,88.093,179.275,88.18Zm9.3-2.932a3.44,3.44,0,0,0,1.221.676c.274.064.415.031.531-.324C190.174,85.363,189.511,85.25,188.578,85.248Zm-4.194-3.256a28.8,28.8,0,0,1-1.224,2.944,25.676,25.676,0,0,1,3.029-.569A20.919,20.919,0,0,1,184.384,81.992Zm-.254-4.567c-.375,0-.394.141-.416.289a3.31,3.31,0,0,0,.353,1.585c.239-1.14.19-1.743.074-1.874Z",
    transform: "translate(-143.577 -71.502)",
    fill: "#e15f78"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingPdf);
export default __webpack_public_path__ + "static/media/loadingPdf.857838d1ad4e087df04622b796d74b79.svg";
export { ForwardRef as ReactComponent };